import { Button, Card, FormControl, Grid, IconButton, Input, InputLabel, MenuItem, OutlinedInput, Select, TextField, Tooltip, Typography } from "@material-ui/core";
import { blueGrey, green, grey, red } from "@material-ui/core/colors";
import { Add, Delete, Info, Remove } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const NameTranslate = ({ names, setNames }) => {
  const { t } = useTranslation();
  //const [lang, setLang] = useState("");
  const [name, setName] = useState("");
  const langList = ["es", "eu", "en"];
  const [updateTime, setUpdateTime] = useState(); //estado pararenderizar cuando se cambian las props

  const addName = (name, l) => {
    names[l] = name;
    setNames(names);
    setName("");
    setUpdateTime(new Date());
  };

  const removeName = (l) => {
    delete names[l];
    setNames(names);
    setUpdateTime(new Date());
  };

  return (
    <Grid item xs={12} container spacing={2}>
      <Grid item xs={12} container alignItems="flex-end">
        <Typography variant="h6" color="primary">
          Título del formulario
        </Typography>
        <Tooltip title={<Typography>Si no se completa alguno de los idiomas se rellenara con el título en castellano</Typography>}>
          <Info color="primary" style={{ paddingBottom: 6, paddingLeft: 4 }} />
        </Tooltip>
        <Typography
          variant="h6"
          style={{
            marginLeft: 6,
            paddingBottom: 2,
            fontSize: "1.1rem",
            color: Object.keys(names)?.length == langList.length ? green[500] : red[500],
          }}
        >
          {t("of", {
            current: Object.keys(names)?.length,
            max: langList.length,
          })}
        </Typography>
      </Grid>

      <Grid item xs={12} container spacing={2}>
        {langList.map((l) =>
          names[l] !== undefined ? (
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <FormControl variant="outlined" fullWidth>
                  <InputLabel>{t(`lang.${l}`)}</InputLabel>
                  <OutlinedInput
                    label={t(`lang.${l}`)}
                    value={names[l]}
                    onChange={(e) => addName(e.target.value, l)}
                    endAdornment={
                      <IconButton onClick={() => removeName(l)}>
                        <Delete />
                      </IconButton>
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Card style={{ padding: 16, borderRadius: 16 }} variant="outlined">
                <Grid container alignItems="center">
                  <Typography variant="h6">{t(`lang.${l}`)}</Typography>
                  <IconButton style={{ marginLeft: 9 }} size="small" onClick={() => addName("", l)}>
                    <Add />
                  </IconButton>
                </Grid>
              </Card>
            </Grid>
          )
        )}
      </Grid>

      {/*<Grid item container xs={12} spacing={2} alignItems="center">
        <Grid item xs={12} md={4} lg={3}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="form-type-select-label">{t("metaFormNane")}</InputLabel>
            <Select labelId="form-type-select-label" value={lang} onChange={(e) => setLang(e.target.value)} label={t("metaFormNane")}>
              {langList.map((e) => (
                <MenuItem value={e}>{t(`lang.${e}`)}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            id="outlined-basic-name"
            label="Nombre del formulario"
            placeholder="Registro Ermua Enero 2022"
            variant="outlined"
            value={name}
            fullWidth
            onChange={(e) => setName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <Button variant="outlined" color="primary" style={{ textTransform: "none", height: 56 }} disabled={!name} onClick={addName}>
            añadir nombre
          </Button>
        </Grid>
        {/*!!names &&
          Object.keys(names).map((n) => (
            <Grid item xs={12} md={6} lg={4}>
              <Card
                variant="outlined"
                style={{
                  padding: 16,
                  backgroundColor: grey[50],
                  borderRadius: 16,
                }}
              >
                <Grid item xs={12}>
                  <Typography variant="h6" color="primary">
                    {t(`lang.${n}`)}
                  </Typography>

                  <Typography variant="h6" color="textSecondary">
                    {names[n]}
                  </Typography>
                </Grid>
              </Card>
            </Grid>
            ))
            </Grid>*/}
    </Grid>
  );
};

export default NameTranslate;

/*const Langs = () => {

    return()
}*/
